import React, { useState } from 'react';
import CountrySelector from '../components/CountrySelector';
import '../styles/RegisterHeader.css'
import '../styles/RegisterMain.css'
import PhoneInput from 'react-phone-number-input';
import RegisterBackground from '../assets/register_header.png';
import RegisterMain from '../assets/justice-svg.svg'
import emailjs from '@emailjs/browser';

const RegisterPage = () => {
    const [registerName, setRegisterName] = useState('');
    const [registerEmail, setRegisterEmail] = useState('');
    const [registerCountry, setRegisterCountry] = useState('');
    const [registerCity, setRegisterCity] = useState('');
    const [registerZipCode, setRegisterZipCode] = useState('');
    const [registerPhoneNumber, setRegisterPhoneNumber] = useState('');
    const [registerPracticeAreas, setRegisterPracticeAreas] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        const formDetails = {
            name: registerName,
            email: registerEmail,
            country: registerCountry,
            city: registerCity,
            zipCode: registerZipCode,
            number: registerPhoneNumber,
            practiceAreas: registerPracticeAreas
        };
        emailjs.send('service_bweo396', 'template_7nv8uoi', formDetails, '3YyDVJ1mlye_xPa7F')
        setRegisterName('')
        setRegisterEmail('')
        setRegisterCity('')
        setRegisterCountry('')
        setRegisterZipCode('')
        setRegisterPhoneNumber('')
        setRegisterPracticeAreas('')
    };

    return (
        <>
            <header>
                <div className="register_header-wrapper">
                    <img src={RegisterBackground} alt="" className="register_header-image" />
                    <div className="register_image-gradient" />
                    <div className="row">
                        <div className="register_header-content">
                            <h1 className="register_header-title">Register With Amderon</h1>
                            <p className="register_header-para">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                        </div>
                    </div>
                </div>
            </header>
            <main>
                <div className="row">
                    <div className="register_main-wrapper">
                        <div className="register_form-wrapper">
                            <h1 className="register_form-title">Register With Amderon</h1>
                            <p className="register_form-para">Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet. Aenean sollicitudin,
                                lorem quis bibendum nisi elit consequat ipsum, nec sagittis sebh id sed sit.
                            </p>
                            <form className="register_form" onSubmit={handleSubmit}>
                                <input required type="text" value={registerName} onChange={(e) => setRegisterName(e.target.value)} className="register_form-name" placeholder="Name" />
                                <input required type="email" value={registerEmail} onChange={(e) => setRegisterEmail(e.target.value)} className="register_form-email" placeholder="Email" />
                                <div className="form_country-city-wrapper">
                                    <CountrySelector value={registerCountry} onChange={(value) => setRegisterCountry(value)} className="register_form-country" />
                                    <input required type="text" value={registerCity} onChange={(e) => setRegisterCity(e.target.value)} className="register_form-city" placeholder="City" />
                                </div>
                                <input required type="text" value={registerZipCode} onChange={(e) => setRegisterZipCode(e.target.value)} className="register_form-zip" placeholder="Zip Code" />
                                <PhoneInput
                                    className="register_form-phone"
                                    placeholder="Phone Number"
                                    defaultCountry="IN"
                                    value={registerPhoneNumber}
                                    onChange={setRegisterPhoneNumber}
                                    required
                                />
                                <input type="text" value={registerPracticeAreas} onChange={(e) => setRegisterPracticeAreas(e.target.value)} placeholder="Practice Areas" className="register_form-practice" />
                                <button type="submit" className="register_form-submit">Register</button>
                            </form>
                        </div>
                        <figure className="register_main-image-wrapper">
                            <img src={RegisterMain} alt="" className="register_main-image" />
                        </figure>
                    </div>
                </div>
            </main>
        </>
    );
}

export default RegisterPage;
